import React from 'react';

const copy = [
  {
    section: 1,
    content: {
      title: (
        <div className="wrapper blue-line">
          <h3>Choosing Security</h3>
        </div>
      ),
      table: (
        <table>
          <tbody>
            <tr>
              <td className="row-title">Name</td>
              <td>Rose</td>
            </tr>
            <tr>
              <td className="row-title">Age</td>
              <td>27</td>
            </tr>
            <tr>
              <td className="row-title">Career</td>
              <td>Receptionist</td>
            </tr>
            <tr>
              <td className="row-title">Location</td>
              <td>New York</td>
            </tr>
          </tbody>
        </table>
      ),
      paragraph: [
        <p>
          As a kid growing up in Arkansas, Rose always felt set apart because of her family’s financial struggles. Things were supposed to be different after she bootstrapped her
          way to a college education and graduated from a prestigious four-year institution. Unfortunately, it wasn’t quite that simple. Now Rose is rethinking her perspective,
          banishing the sense of shame that she’s often experienced around money, and realizing that, for her, wealth is about supporting herself, enjoying life, and feeling less
          anxious.
        </p>,
        <h4>What choices have you made to get where you are now?</h4>,
        <p>
          My family was very poor growing up, and I attended an expensive college almost entirely on financial aid. After I graduated, I worked in publishing and then became a
          cocktail waitress to earn more money and pay off my loans. Eventually, I realized that wasn’t working for me, so I took my current job, as a receptionist at a private
          equity firm, mostly for the salary and benefits.
        </p>,

        <h4>How are you reimagining wealth?</h4>,
        <p>
          I can’t say I feel completely financially secure yet—that won’t happen until I pay off my debts—but I’m in a better place than I’ve been in the past, which means I’m able
          to do things like travel. I definitely eat out more, which gets knocked a lot, but frankly is awesome.
        </p>,
        <p>
          I still sometimes feel guilty about it because of the way I grew up, but I’ve put a lot of work into learning money management skills so that I’m not living paycheck to
          paycheck anymore. The company I’m working for now offers a very cushy retirement savings plan, which has helped me feel more secure about the future.
        </p>,
        <h4 className="pink">To me, wealth is security. </h4>,
      ],
    },
  },
  {
    section: 2,
    content: {
      title: (
        <div className="wrapper yellow-line">
          <h3>Rebuilding A Dream</h3>
        </div>
      ),
      table: (
        <table>
          <tbody>
            <tr>
              <td className="row-title">Name</td>
              <td>Debby</td>
            </tr>
            <tr>
              <td className="row-title">Age</td>
              <td>55</td>
            </tr>
            <tr>
              <td className="row-title">Career</td>
              <td>Salon Owner</td>
            </tr>
            <tr>
              <td className="row-title">Location</td>
              <td>North Carolina</td>
            </tr>
          </tbody>
        </table>
      ),
      paragraph: [
        <p>
          Debby has always defined herself through the sense of empowerment that comes from being her own boss. But business ownership has its ups and downs, and Debby found
          herself facing setbacks after she reopened her salon in a new location several years ago. Now she’s rebuilding, and has created a stronger foundation for herself in the
          process. The way she sees it, the challenge is what she signed up for—and it’s what makes life interesting.
        </p>,
        <h4>What are the strategies that have helped you make your business stronger? </h4>,
        <p>
          For me, it’s about collaboration and making choices. I work with an accountant and planner who puts aside money each month and helps me make sure it all adds up. When
          there’s a shortfall I work longer hours and gather more clients. My motto is, “I don’t give up.”
        </p>,

        <h4>Were there any moments when it was hard to maintain that optimism? </h4>,
        <p>
          Some of my retirement plans got complicated when I had to reopen in a new location. In some ways, it was like starting all over. But I love my career, and I don’t want to
          retire until I have to.
        </p>,
        <h4>How are you reimagining wealth? </h4>,
        <p>
          I started to turn a profit again at the end of last year. That took some time in the new location. But I always remind myself that, as a small business owner, I’m the one
          who controls how much money I make. It can be a rollercoaster, but the freedom makes it worth it.
        </p>,

        <h4 className="pink">To me, wealth is freedom. </h4>,
      ],
    },
  },
  {
    section: 3,
    content: {
      title: (
        <div className="wrapper pink-line ">
          <h3>Seeing the World</h3>
        </div>
      ),
      table: (
        <table className="long-table">
          <tbody>
            <tr>
              <td className="row-title">Name</td>
              <td>Ron</td>
            </tr>
            <tr>
              <td className="row-title">Age</td>
              <td>38</td>
            </tr>
            <tr>
              <td className="row-title">Career</td>
              <td>Children's Television Writer</td>
            </tr>
            <tr>
              <td className="row-title">Location</td>
              <td>California</td>
            </tr>
          </tbody>
        </table>
      ),
      paragraph: [
        <p>
          Since his 20’s, Ron has carefully built a career in children’s television, working as a writer and show-runner on some of the most well-known shows out there. It’s been
          no small feat to make it in such an unpredictable industry: as a freelancer, paychecks are unpredictable, and months between gigs can be commonplace. But while Ron has
          never slowed his hustle, he’s also made a point of organizing his work around his life, rather than the other way around.
        </p>,
        <h4>You’ve worked mostly as a freelancer. How have you squared that with the need for security? </h4>,
        <p>
          There’s a level of anxiety that you have to be comfortable with as a freelancer. I’ve always had a philosophy of keeping my overhead low and spending less than I could
          afford, to keep that anxiety at bay. You have to remind yourself to be happy where you are, otherwise you feel like you’re always looking up at a taller mountain.
        </p>,

        <h4>How are you reimagining wealth? </h4>,
        <p>
          The most important thing in my life is travel. In 2008, after a trip to Africa, I realized that I wanted to see as much as I could of the world while I was still young
          and healthy enough to get the most out of it. And I was already building a life that gave me the flexibility to do that.
        </p>,
        <p>
          The great thing about freelance writing is that you can do it anywhere. At one point, I spent three months in Brussels; I just took my work with me. I’m sure I’ve passed
          up career opportunities in order to travel so much. There are probably shows that I didn’t get staffed on because I spend so much time away from LA, but I don’t regret
          it. I’m living life based on my own priorities.
        </p>,

        <h4 className="pink">To me, wealth is travel. </h4>,
      ],
    },
  },
  {
    section: 4,
    content: {
      title: (
        <div className="wrapper pink-line">
          <h3>Changing the game</h3>
        </div>
      ),
      table: (
        <table>
          <tbody>
            <tr>
              <td className="row-title">Name</td>
              <td>James</td>
            </tr>
            <tr>
              <td className="row-title">Age</td>
              <td>39</td>
            </tr>
            <tr>
              <td className="row-title">Career</td>
              <td>Graduate Student</td>
            </tr>
            <tr>
              <td className="row-title">Location</td>
              <td>Connecticut</td>
            </tr>
          </tbody>
        </table>
      ),
      paragraph: [
        <p>
          After graduating from an Ivy League law school, James quickly found himself climbing the ladder of success. By his early 30’s he had made partner in his law firm, and
          although he was thriving financially, he felt bored and unfulfilled. Recently, he decided it was time to shake things up: he left his law partnership to go back to
          graduate school, where he’s studying English with an eye toward a new career in academia.
        </p>,
        <h4>You just made a huge life change. How were you able to do it? </h4>,
        <p>
          As soon as I paid off my student loans, I started saving. I was maxing out my 401(k) every single year, and putting anything I had left over after into investments. One
          day, I came home from work, looked at the numbers and realized I had saved enough that I could really take a hard look at what I wanted out of life, and really make a
          change.
        </p>,

        <h4>How are you reimagining wealth? </h4>,
        <p>
          I don’t have an income now, which means I’m having to rethink my sources of enjoyment. When I was working, I was miserable every second of the day, but I had money, so I
          used that money to be happy outside of work. In other words, taking lots of vacations and eating out. Now I’m putting those things on hold for awhile, but the funny thing
          is that I don’t really miss them. Instead, I’m spending all day doing what I’ve always really loved: reading books, thinking about them, and writing about them.
        </p>,
        <p>
          I’m a million times happier now, but I don’t regret that it’s taken me this long to get here. If I hadn’t done the other stuff, I wouldn’t have been able to do what I’m
          doing now.
        </p>,

        <h4 className="pink">To me, wealth is fulfillment. </h4>,
      ],
    },
  },
  {
    section: 5,
    content: {
      title: (
        <div className="wrapper yellow-line">
          <h3>Looking to the future</h3>
        </div>
      ),
      table: (
        <table>
          <tbody>
            <tr>
              <td className="row-title">Name</td>
              <td>Michael</td>
            </tr>
            <tr>
              <td className="row-title">Age</td>
              <td>67</td>
            </tr>
            <tr>
              <td className="row-title">Career</td>
              <td>Contractor</td>
            </tr>
            <tr>
              <td className="row-title">Location</td>
              <td>Michigan</td>
            </tr>
          </tbody>
        </table>
      ),
      paragraph: [
        <p>
          Michael is a 67-year-old contractor and father of two. Though he’s worked in construction in much of the United States, he’s always returned to his hometown of Detroit,
          where some of his most fulfilling work has involved rehabilitating the city’s historic but challenged downtown area. As Michael approaches retirement, he finds himself
          taking stock and considering what wealth, security, and success really mean.
        </p>,
        <h4>You’ve had a long career. Where have you found satisfaction? </h4>,
        <p>I like that I’m not a typical new house subdivision builder. I’ve mostly built and rehabilitated affordable housing. It just makes me feel better.</p>,

        <h4>Are you ready for retirement? </h4>,
        <p>
          The point of real comfort, for me, came after I saw that the number I had saved, along with the social security income I’m expecting, will exceed my budget for ten years.
          I’m planning on retiring at least partially when I’m 70, and that will give me the freedom to do it.
        </p>,

        <h4>How are you reimagining wealth? </h4>,
        <p>
          It took me a long time to realize that security, in almost any sense, is elusive and mostly in your head. In a lot of ways, I’ve figured out that I have to find that
          sense of security in myself.
        </p>,
        <p>
          And I’m lucky that I’ve already been able to do many of the things that I wanted to, and that when I retire, I’ll be able to do more of those things-- traveling and
          meeting new people. I’ve been lucky.
        </p>,

        <h4 className="pink">To me, wealth is contentment. </h4>,
      ],
    },
  },
];

export default copy;
